import { ecf2rae, eci2ecf, lla2ecf } from '@ootk/src/main';
import { Line, LineColors } from './line';
import { ServiceLocator } from '@app/engine/core/service-locator';
export class SatScanEarthLine extends Line {
    sat;
    lat_ = -90;
    lon_ = 0;
    constructor(sat, color = LineColors.GREEN) {
        super();
        this.sat = sat;
        this.validateColor(color);
        this.color_ = color;
    }
    update() {
        const eci = this.sat.eci(ServiceLocator.getTimeManager().simulationTimeObj);
        const eciArr = [eci.position.x, eci.position.y, eci.position.z];
        let t = 0;
        while (t < 1000) {
            this.updateLongitude_();
            this.updateLatitude_();
            const lla = { lat: this.lat_, lon: this.lon_, alt: 0.05 };
            const ecf = eci2ecf(this.sat.position, 0);
            const rae = ecf2rae(lla, ecf);
            const el = rae.el;
            if (el > settingsManager.lineScanMinEl) {
                const pos = lla2ecf(lla);
                const eciArr2 = [pos.x, pos.y, pos.z];
                this.updateVertBuf([eciArr, eciArr2]);
                break;
            }
            this.adjustLatitude_();
            t++;
        }
    }
    updateLongitude_() {
        this.lon_ = (this.lon_ + settingsManager.lineScanSpeedSat);
        if (this.lon_ > 180) {
            this.lon_ = -180;
        }
    }
    updateLatitude_() {
        if (this.lon_ >= 0 && this.lon_ < settingsManager.lineScanSpeedSat) {
            this.lat_ = (this.lat_ + settingsManager.lineScanSpeedSat);
        }
        if (this.lat_ > 90) {
            this.lat_ = -90;
        }
    }
    adjustLatitude_() {
        if (this.lat_ === -90) {
            this.lat_ = (this.lat_ + settingsManager.lineScanSpeedSat);
        }
        if (this.lat_ === 90) {
            this.lat_ = -90;
        }
    }
}
